import { render, staticRenderFns } from "./MandatsModelNews.vue?vue&type=template&id=57380b14&"
import script from "./MandatsModelNews.vue?vue&type=script&lang=js&"
export * from "./MandatsModelNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports